module.exports = [{"type":"title","text":"2024-01-23"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續新增接口:查詢標記價格K線數據"},{"type":"html","text":"永续:新增WS DataType-24小時價格變動推送"},{"type":"html","text":"永续:新增WS DataType-最新成交價格推送"},{"type":"html","text":"永续:新增WS DataType-最新標記價格推送"},{"type":"html","text":"新增：用戶查詢風控中的充值記錄 接口"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-01-23.json
// module id = G8cI
// module chunks = 3